angular
  .module("admin.reports")
  .controller(
    "CommercialReportCtrl",
    function ($http, config, ReportsResource) {
      this.isExporting = false;

      this.generateExcel = function () {
        this.isExporting = true;
        $http({
          url: config.api + "/api/v1/reports/commercial/export",
          method: "GET",
          responseType: "arraybuffer",
        }).then(
          (res) => {
            const downloadFile = ({ blob, fileName }) => {
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement("a");

              a.href = url;
              a.download = fileName;

              a.dispatchEvent(
                new MouseEvent("click", {
                  view: window,
                  bubbles: true,
                  cancelable: false,
                })
              );

              window.URL.revokeObjectURL(url);
            };

            this.isExporting = false;
            const blob = new Blob([res.data], {
              type: "text/csv;charset=utf-8;",
            });
            downloadFile({ blob: blob, fileName: "RelatorioComercial.csv" });
          },
          (error) => {
            console.error("[CommercialReportCtrl] Erro ao exportar:", error);
            this.isExporting = false;
          }
        );
      };
    }
  );
